module.exports = __webpack_public_path__ + "static/media/spot2.ac2876ca.png";